class ImageReveal {
	constructor( el ) {

		let image = el.querySelector("img");
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				toggleActions: "restart none none reset"
			}
		});

		tl.set(el, { autoAlpha: 1 });
		tl.from(el, 1.5, {
			xPercent: -100,
			ease: Power2.out
		});
		tl.from(image, 1.5, {
			xPercent: 100,
			scale: 1.3,
			delay: -1.5,
			ease: Power2.out
		});

	}
}

export default ImageReveal;
